<div class="org-selector" [class.open]="isOpen" [class.disabled]="disabled" [class.small]="size === 'small'" [class.large]="size === 'large'" [class.theme-dark]="theme === 'dark'">
  <!-- Trigger Button -->
  <button class="selector-trigger" (click)="toggleDropdown()" [disabled]="disabled" type="button">
    <!-- Show "All Organizations" when selected -->
    <div class="selected-display all-selected" *ngIf="isAllSelected && allowAll">
      <div class="org-avatar mini all-avatar">
        <i class="fa-solid fa-globe"></i>
      </div>
      <div class="selected-info">
        <span class="selected-name">{{ allLabel }}</span>
      </div>
    </div>
    <!-- Show selected org -->
    <div class="selected-display" *ngIf="selectedOrg && !isAllSelected">
      <div class="org-avatar mini" *ngIf="!selectedOrg.LogoURL">
        {{ getInitials(selectedOrg.Name) }}
      </div>
      <div class="org-logo mini" *ngIf="selectedOrg.LogoURL">
        <img [src]="selectedOrg.LogoURL" [alt]="selectedOrg.Name">
      </div>
      <div class="selected-info">
        <span class="selected-name">{{ selectedOrg.Name }}</span>
        <span class="selected-path" *ngIf="getOrgPath(selectedOrg).includes(' → ')">
          {{ getOrgPath(selectedOrg) }}
        </span>
      </div>
    </div>
    <!-- Placeholder when nothing selected -->
    <div class="placeholder" *ngIf="!selectedOrg && !isAllSelected">
      <i class="fa-solid fa-building"></i>
      <span>{{ placeholder }}</span>
    </div>
    <i class="fa-solid chevron" [class.fa-chevron-down]="!isOpen" [class.fa-chevron-up]="isOpen"></i>
  </button>

  <!-- Dropdown Panel (uses fixed positioning to avoid clipping) -->
  <div class="dropdown-panel" *ngIf="isOpen" [ngStyle]="dropdownStyle">
    <!-- Search -->
    <div class="dropdown-search">
      <i class="fa-solid fa-search"></i>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Search organizations..."
        (click)="$event.stopPropagation()"
      />
      <button class="clear-btn" *ngIf="searchQuery" (click)="searchQuery = ''; $event.stopPropagation()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <!-- Organization List -->
    <div class="dropdown-list">
      <!-- All Organizations Option -->
      <div
        class="org-item all-orgs-item"
        *ngIf="allowAll && !searchQuery"
        [class.selected]="isAllSelected"
        (click)="selectAll($event)"
      >
        <div class="org-avatar all-avatar">
          <i class="fa-solid fa-globe"></i>
        </div>
        <div class="org-info">
          <span class="org-name">{{ allLabel }}</span>
        </div>
        <i class="fa-solid fa-check selected-check" *ngIf="isAllSelected"></i>
      </div>

      <!-- Separator -->
      <div class="org-list-separator" *ngIf="allowAll && !searchQuery && flattenedTreeNodes.length > 0"></div>

      <div class="empty-state" *ngIf="flattenedTreeNodes.length === 0">
        <i class="fa-solid fa-building"></i>
        <span *ngIf="searchQuery">No organizations match "{{ searchQuery }}"</span>
        <span *ngIf="!searchQuery">No organizations available</span>
      </div>

      <ng-container *ngFor="let node of flattenedTreeNodes">
        <div
          class="org-item"
          [class.selected]="isSelected(node.org)"
          [class.has-children]="node.hasChildren"
          [style.padding-left.px]="12 + (searchQuery ? 0 : node.depth * 20)"
          (click)="selectOrg(node.org, $event)"
        >
          <!-- Expand/Collapse Toggle -->
          <button
            class="expand-toggle"
            *ngIf="node.hasChildren && !searchQuery"
            (click)="toggleExpand(node, $event)"
          >
            <i class="fa-solid" [class.fa-chevron-down]="node.expanded" [class.fa-chevron-right]="!node.expanded"></i>
          </button>
          <span class="expand-placeholder" *ngIf="!node.hasChildren && !searchQuery"></span>

          <!-- Avatar / Logo -->
          <div class="org-avatar" [class.parent-org]="node.hasChildren" *ngIf="!node.org.LogoURL">
            {{ getInitials(node.org.Name) }}
          </div>
          <div class="org-logo" [class.parent-org]="node.hasChildren" *ngIf="node.org.LogoURL">
            <img [src]="node.org.LogoURL" [alt]="node.org.Name">
          </div>

          <!-- Info -->
          <div class="org-info">
            <span class="org-name">{{ node.org.Name }}</span>
            <div class="org-meta">
              <span class="channel-count" *ngIf="showChannelCount && getChannelCount(node.org) > 0">
                <i class="fa-solid fa-broadcast-tower"></i>
                {{ getChannelCount(node.org) }}
              </span>
              <span class="sub-org-count" *ngIf="showSubOrgCount && node.hasChildren">
                <i class="fa-solid fa-sitemap"></i>
                {{ getDescendantCount(node) }}
              </span>
            </div>
          </div>

          <!-- Selected Check -->
          <i class="fa-solid fa-check selected-check" *ngIf="isSelected(node.org)"></i>
        </div>
      </ng-container>
    </div>
  </div>
</div>
